import { MODULES, FEATURES } from '@src/quince-site-common/src/constants/template-info'
import { captureFatalException } from '@src/quince-site-common/src/utils/sentryUtil'
import { handleSgtmApi } from '@src/telemetry/handleSgtmApi'

import { isBotAgent } from '../mixpanel/mixpanel.helper'

const trackPixelWithSGTM = (properties: any, shouldProcessResponseHeaders = false) => {
  try {
    if (!isBotAgent()) {
      handleSgtmApi(properties, 'server_pixel_sgtm_api', 'server_pixel_properties', shouldProcessResponseHeaders)
    }
  } catch (err) {
    captureFatalException(`Failed to track event with pixel through sgtm: ${JSON.stringify(err)}`, {
      module: MODULES.SERVER_PIXEL,
      feature: FEATURES.SERVER_PIXEL_API,
    })
  }
}

export { trackPixelWithSGTM }
